import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Form, reduxForm } from 'redux-form';
import { propBool, propFunc, propShape, propStr, } from '../../helpers/custom-prop-types';
import { getFormShowErrors } from '../../helpers/form';
import { isRequiredText, strMax } from '../../validate/utils';
import FreeIcon from '../Icon/Svg/FreeIcon';
import SubmitButton from '../Ui/Button/SubmitButton';
import BlurText from '../Ui/Common/BlurText';
import PlainTextAreaField from '../Ui/Common/Fields/PlainTextAreaField';
export const validateText = [
    isRequiredText('お問い合わせ内容を入力してください'),
    strMax(2000, 'お問い合わせ内容は2000文字以内で入力してください'),
];
const ProffitMartRecommendedImpl = (props) => {
    const { forSearchConsultant, handleSubmit, isBlur, isDisabled, submitting, thisForm, } = props;
    const hasShowError = getFormShowErrors(thisForm).length > 0;
    return (_jsxs(Form, Object.assign({ className: `l-proffit-choice ${forSearchConsultant ? 'is-search-consultant' : 'mb50'}`, onSubmit: handleSubmit }, { children: [_jsxs(BlurText, Object.assign({ className: 'choice_title', component: 'h2', isBlur: isBlur }, { children: [_jsx(FreeIcon, {}), forSearchConsultant
                        ? 'おすすめのコンサルを聞く'
                        : 'おすすめのプロジェクト事例を聞く'] })), forSearchConsultant ? (_jsx(BlurText, Object.assign({ className: 'choice_text', component: 'p', isBlur: isBlur, isCenter: true }, { children: "\u7686\u3055\u307E\u306E\u3054\u8981\u671B\u306B\u30D5\u30A3\u30C3\u30C8\u3059\u308B\u30B3\u30F3\u30B5\u30EB\u30BF\u30F3\u30C8\u3084\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u4E8B\u4F8B\u3092\u53B3\u9078\u3057\u3066\u30011\u55B6\u696D\u65E5\u4EE5\u5185\u306B\u3054\u7D39\u4ECB\u3057\u307E\u3059" }))) : (_jsxs("p", Object.assign({ className: 'choice_text' }, { children: ["\u7686\u3055\u3093\u306E\u3054\u8981\u671B\u306B\u30D5\u30A3\u30C3\u30C8\u3059\u308B\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u4E8B\u4F8B\u3092\u53B3\u9078\u3057\u3066", _jsx("br", {}), "\uFF11\u55B6\u696D\u65E5\u4EE5\u5185\u306B\u3054\u7D39\u4ECB\u3057\u307E\u3059"] }))), _jsx("br", {}), _jsx(PlainTextAreaField, { autosized: true, disabled: isDisabled, name: 'text', placeholder: ' 例 : カスタマージャーニーを短期間でまとめてほしい\n 例 : 新事業のアイデア出しを支援してほしい', validate: validateText }), _jsx(SubmitButton, { className: `${forSearchConsultant ? '' : 'btn btn-primary'}`, isDisabled: isDisabled || hasShowError || submitting, isLoading: submitting, text: _jsx(BlurText, Object.assign({ component: 'span', isBlur: isBlur }, { children: "\u4E0A\u8A18\u5185\u5BB9\u3067\u9001\u4FE1\u3059\u308B" })) })] })));
};
ProffitMartRecommendedImpl.propTypes = {
    forSearchConsultant: propBool(),
    handleSubmit: propFunc().isRequired,
    isBlur: propBool(),
    isDisabled: propBool(),
    submitting: propBool().isRequired,
    thisForm: propShape().isRequired,
};
ProffitMartRecommendedImpl.defaultProps = {
    forSearchConsultant: false,
    isBlur: false,
    isDisabled: false,
};
const enhance = compose(connect(({ form }, { form: formName }) => ({
    thisForm: form[formName] || {},
})), reduxForm());
const ProffitMartRecommended = enhance(ProffitMartRecommendedImpl);
ProffitMartRecommended.propTypes = {
    form: propStr(),
};
ProffitMartRecommended.defaultProps = {
    form: 'ProffitMartRecommended',
};
export default ProffitMartRecommended;
